module.exports = __webpack_public_path__ + "static/media/силовые -Тренажер «разгибание ног».6c6fdd1c.jpg";